//  漢堡按鈕
'use client';

import { useDispatch, useSelector } from 'react-redux';
import { setShowMenu, popState } from '@/slices/popSlice';
import Image from 'next/image';

const HamburgerButton = () => {
    const dispatch = useDispatch();
    const { showMenu } = useSelector(popState);

    const onToggle = () => dispatch(setShowMenu(!showMenu));

    return (
        <button className="img-box w-[30px] h-[30px] trans hover:opacity-[.7]" onClick={onToggle}>
            <Image width={30} height={30} src="/images/icon/icon_hamburger.svg" alt="icon" />
        </button>
    );
};

export default HamburgerButton;
